// extracted by mini-css-extract-plugin
export default {"widget_container":"CFWidget_widget_container__qIb9g","widget_left":"CFWidget_widget_left__+VMOw","widget_right":"CFWidget_widget_right__XbDmv","cf_count":"CFWidget_cf_count__WO1CN"};